// extracted by mini-css-extract-plugin
module.exports = {"content":"ComprovanteDePagamento_content__2-E1x","th_tr_Responsive":"ComprovanteDePagamento_th_tr_Responsive__34ZHD"};